import { useDocument } from './useDocument';

const SETTINGS_PATH = 'settings';

type Settings = {
  urls: {
    host: string;
    jpuAppBaseUrl: string;
    redirectUrl: string;
  };
};

export const useSetting = (name: 'urls') => {
  const { data, error, state } = useDocument<Settings[typeof name]>(
    `${SETTINGS_PATH}/${name}`,
    true,
  );

  return {
    [name]: data,
    state,
    error,
  };
};
